import CallToActionButtonMessageRenderer from '@alme/ui-web/modules/message-renderer-call-to-action/src/message-renderer-call-to-action'
import { CallToActionResponseAction } from '@alme/ui-web/modules/message-renderer-call-to-action/src/models/CallToActionResponseActions';
import { SingleLinkRenderer } from '@alme/ui-web/modules/message-renderer-call-to-action/src/models/SingleLinkRenderer'
import { LinkSpec } from '@alme/ui-web/settings/button-collection';
import { DefaultSettings } from '@alme/ui-web/settings/settings-util'
import { Dictionary, Mutator } from '@alme/ui-web/types/rendering';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import LaunchOffersEventUtility from '../launch-offers-appevent-utility/launchOffersAppEventUtility';
import {VNode} from 'virtual-dom';

type StepOutIcon = { renderIcon: (url: string) => VNode | undefined };
type MutatorModule = { getMutator: () => Mutator };

export default class CustomCallToActionButtonMessageRenderer extends CallToActionButtonMessageRenderer{

    _launchOfferUtil: LaunchOffersEventUtility;

    constructor(passedSettings: AlightCustomSettingsType | null, singleLinkRenderer: SingleLinkRenderer, stepOutIcon: StepOutIcon | null = null, launchOfferUtil: LaunchOffersEventUtility, 
        mutatorModules: MutatorModule[] = [])
    {
        super(passedSettings, singleLinkRenderer, stepOutIcon, mutatorModules);
        this._launchOfferUtil = launchOfferUtil;
    }

    buildLinkSpec(config: CallToActionResponseAction, entryId: string, stepOutNode:VNode): LinkSpec
    {
        const alightSettings = this._settings as AlightCustomSettingsType;
        const shouldDisable = this.shouldDisable(entryId);
        const {callToActionButtonDisabled, callToActionButton} = this._settings.classNames;

        const isAppEvent = this.isAppEvent(config.ButtonType);

        let params = Object.assign({ entryId }, config.parameters);;

        if(isAppEvent && alightSettings.AppEvents.launchOfferTypes.includes(config.ButtonTarget)){
            const launchParams = this._launchOfferUtil.GenerateParameters(config.ButtonTarget);
            if(launchParams !== null && launchParams !== undefined){
                Object.entries(launchParams).forEach(([key, value]) => {params[key] = value})
            };
            
        }
 

        let linkSpec = {
            tag: "a",
            TargetType: config.ButtonType,
            Metadata: this.buildLinkSpecMetadata(config),
            AppeventName: isAppEvent ? config.ButtonTarget : "",
            PreAlme: this.buildPreAlmeFunction(config),
            DisplayText: stepOutNode ? [config.ButtonDisplayText, stepOutNode] :config.ButtonDisplayText,
            parameters: params,
            attributes: {
                "type": "a",
                "title": config.ButtonDisplayText,
                'aria-label': config.ButtonDisplayText,
            },
            className: shouldDisable ? callToActionButtonDisabled : callToActionButton,
            disabled: shouldDisable,
        } as LinkSpec;

        if (entryId)
        {
            linkSpec.id = `nit-call-to-action-${entryId}`;
        }

        // run mutators to update properties
        linkSpec = this._mutators.reduce((props, mutate) => mutate(props), linkSpec as unknown as Dictionary) as unknown as LinkSpec;

        return linkSpec;
    }
}


// WEBPACK FOOTER //
// ./modules/custom-message-renderer-call-to-action/message-renderer-call-to-action.ts